var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.846313H24V16.6435H0V0.846313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.99765H24V11.4921H0V5.99765Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.4921H24V16.6435H0V11.4921Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06836 5.31075V9.25098C6.06836 11.4924 9.034 12.1791 9.034 12.1791C9.034 12.1791 11.9995 11.4923 11.9995 9.25098V5.31075H6.06836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84961 5.42621V9.21858C6.84961 9.47183 6.90656 9.71101 7.01944 9.93525H11.0493C11.1622 9.71106 11.2191 9.47188 11.2191 9.21858V5.42621H6.84961Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3735 8.07042H9.36917V7.40938H10.0387V6.74834H9.36917V6.08725H8.69966V6.74834H8.03019V7.40938H8.69966V8.07042H7.69531V8.73151H8.69966V9.39255H9.36917V8.73151H10.3735V8.07042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93266 10.858C8.36409 11.1257 8.80734 11.2812 9.03431 11.3503C9.26128 11.2811 9.70453 11.1257 10.136 10.858C10.5711 10.5881 10.8761 10.2792 11.0493 9.93521C10.8518 9.79695 10.6156 9.72281 10.3734 9.7231C10.2817 9.7231 10.1927 9.73384 10.1071 9.75351C9.92564 9.34641 9.51375 9.06206 9.03441 9.06206C8.55502 9.06206 8.14317 9.34641 7.96172 9.75351C7.8744 9.73336 7.78504 9.72316 7.69537 9.7231C7.45326 9.72282 7.21705 9.79695 7.01953 9.93521C7.19255 10.2792 7.49756 10.5881 7.93266 10.858Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.7975,
    fill: "white",
    transform: "translate(0 0.84613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.e5e171f61d64cfd2ada034f414e77a95.svg";
export { ForwardRef as ReactComponent };